import React, { useState } from 'react';
import FlightsMapContainer from "./FlightsMapContainer";

const ShipmentTrackingForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;

  const [record, setRecord] = useState(props.record);

  if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
    setRecord(props.record);
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      {record ?
      <div>
        <div style={{width: "100%", textAlign: "center"}}>
          <div style={{display: "inline-block", maxWidth: 1000, width: "calc(100vw - 600px)", aspectRatio: "16/6"}}>
            <FlightsMapContainer record={props.record} routeListener={props.routeListener}/>
          </div>
        </div>
      </div>
      :<></>
    }
    </div>
  );
}

export default ShipmentTrackingForm;
